import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { teacherForm } from './atoms';
import { ButtonKVBase, CircleSpinner, InputKVBase, SimpleCheckboxBase } from '@/presentation/components';
import { fromCardinal } from '@/presentation/functions/cardinal';
import Styles from './teacher-form-styles.scss';
import { ELEMENTARY, HIHG_SCHOOL, MIDDLE_SCHOOL } from '@/presentation/constants/class-grades';
import Select from './select/select';
import { USER_TITLES } from '@/presentation/constants/user-titles';
const TeacherForm = ({ title, validation, onConfirmClick, formRef, emailDisabled = false }) => {
    const [formState, setFormState] = useRecoilState(teacherForm);
    useEffect(() => {
        if (formState.firstName)
            validate('firstName');
    }, [formState.firstName]);
    useEffect(() => {
        var _a;
        if (((_a = formState === null || formState === void 0 ? void 0 : formState.title) === null || _a === void 0 ? void 0 : _a.value) === undefined) {
            setFormState(prev => (Object.assign(Object.assign({}, prev), { title: '' })));
        }
    }, [formState.title]);
    useEffect(() => {
        if (formState.lastName)
            validate('lastName');
    }, [formState.lastName]);
    useEffect(() => {
        if (formState.email)
            validate('email');
    }, [formState.email]);
    const validate = (field) => {
        setFormState(prev => {
            const formData = Object.assign({}, prev);
            const error = validation.validate(field, formData);
            formData[`${field}Error`] = error;
            formData.isFormInvalid = !!formData.emailError || !!formData.firstNameError || !!formData.lastNameError;
            return Object.assign({}, formData);
        });
    };
    const isFormEmpty = () => {
        return formState.firstName === '' || formState.lastName === '' || formState.email === '';
    };
    const buildCheckBox = (label, key, defaultChecked) => {
        return (React.createElement("div", { className: Styles.checkboxWrap, key: key },
            React.createElement("div", { style: { padding: '0.2rem' } },
                React.createElement(SimpleCheckboxBase, { name: `check-${label}`, defaultChecked: defaultChecked })),
            React.createElement("div", { className: Styles.text }, label)));
    };
    const isThisChecked = (label, grades) => {
        try {
            return grades.includes(fromCardinal(label));
        }
        catch (error) {
            return false;
        }
    };
    return (React.createElement("form", { method: "post", className: Styles.formWrap, ref: formRef },
        React.createElement("h1", null, title),
        React.createElement("div", { className: Styles.subtitle }, "Teacher Information"),
        React.createElement("div", { className: Styles.namesWrap },
            React.createElement("div", { className: Styles.title },
                React.createElement(Select, { name: "title", label: "TITLE", state: formState, setState: setFormState, placeholder: 'ie. Mr.', options: USER_TITLES.map(item => ({
                        value: `${item}`,
                        label: `${item}`
                    })) })),
            React.createElement("div", { className: Styles.firstName },
                React.createElement(InputKVBase, { type: 'text', name: 'firstName', placeholder: 'ie. Guy', label: 'FIRST NAME', state: formState, setState: setFormState, defaultValue: formState === null || formState === void 0 ? void 0 : formState.firstName, required: true })),
            React.createElement("div", { className: Styles.lastName },
                React.createElement(InputKVBase, { type: 'text', name: 'lastName', placeholder: 'ie. Green', label: 'LAST NAME', state: formState, setState: setFormState, defaultValue: formState === null || formState === void 0 ? void 0 : formState.lastName, required: true }))),
        React.createElement("div", { className: Styles.emailWrap },
            React.createElement(InputKVBase, { type: 'email', name: 'email', placeholder: 'ie. hawkins@mail.com', label: 'EMAIL', state: formState, setState: setFormState, defaultValue: formState === null || formState === void 0 ? void 0 : formState.email, required: true, disabled: emailDisabled })),
        React.createElement("div", { className: Styles.detailWrap },
            React.createElement("div", { className: Styles.title }, "What class grades does this teacher teach?"),
            React.createElement("div", { className: Styles.subtitle }, "please select at least one option")),
        React.createElement("div", { className: Styles.gradeWrap },
            React.createElement("div", null,
                React.createElement("div", { className: Styles.title }, "Elementary"),
                ELEMENTARY.map((item, key) => buildCheckBox(item, key, isThisChecked(item, formState === null || formState === void 0 ? void 0 : formState.grades)))),
            React.createElement("div", null,
                React.createElement("div", { className: Styles.title }, "Middle School"),
                MIDDLE_SCHOOL.map((item, key) => buildCheckBox(item, key, isThisChecked(item, formState === null || formState === void 0 ? void 0 : formState.grades)))),
            React.createElement("div", null,
                React.createElement("div", { className: Styles.title }, "High School"),
                HIHG_SCHOOL.map((item, key) => buildCheckBox(item, key, isThisChecked(item, formState === null || formState === void 0 ? void 0 : formState.grades))))),
        React.createElement("div", { className: Styles.btnWrap }, formState.isLoading ? (React.createElement(CircleSpinner, null)) : (React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: onConfirmClick, testId: "btn-save-record", disabled: formState.isFormInvalid || isFormEmpty() }, "Confirm")))));
};
export default TeacherForm;
